// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".drop-down-base{\n  z-index:1000\n}\n.drop-down-base .tooltip-arrow{\n  width:0;\n  height:0;\n  border-style:solid;\n  position:absolute;\n  margin:5px;\n  border-color:transparent;\n  z-index:1\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
